export default {
    "fr": {
        "My missions": "Mes interventions",
        "My archived missions": "Mes interventions archivés",
        "View my archived missions": "Voir les missions archivés",
        "View my current missions": "Voir les missions en cours",
        "No missions": "Aucune intervention pour le moment",
        "Reference": "Référence",
        "Reference ASA": "Référence ASA",
        "Edit reference": "Modifier la référence",
        "Set your reference": "Indiquez votre référence client",
        "Set your document name": "Indiquez votre nom de document",
        "Set your registrations": "Indiquez vos plaques d'immatriculation",
        "Set your notes": "Indiquez vos notes",
        "Date": "Date",
        "Status": "État",
        "report": "Rapport",
        "Price": "Prix",
        "Details": "Détails",
        "Notes": "Notes",
        "Billing": "Facturation",
        "Service": "Service",
        "Quantity": "Quantité",
        "Total": "Total",
        "Empty messages": "Aucun message pour le moment",
        "Total services amount :": "Total des services :",
        "statuses": {
            "current": "En cours",
            "pending": "En attente",
            "achieved": "Terminée"
        },
        "Registration trailer": "Immatriculation remorque",
        "Registration towing": "Immatriculation tracteur",
        "Empty checkpoints": "Aucun suivi pour le moment",
        "Checkpoints": "Suivi d'intervention",
        "Documents": "Documents",
        "Pictures": "Photos",
        "Empty documents": "Aucun document pour le moment",
        "Add a document": "Ajouter un document ...",
        "Your truck :": "Votre camion :",
        "Started on :": "Commencée le :",
        "Ended on :": "Terminée le :",
        "Duration :": "Durée :",
        "Status of mission": "Statut de la mission",
        "Messenger": "Conversation",
        "Document name required": "Le nom du document est obligatoire pour pouvoir uploader votre document. Il doit comporter au moins 5 caractères. Vérifier que le type de fichier ne figure pas déjà dans la liste.",
        "Additional costs": "Cher client, nous vous informons que des frais additionnels sont en cours sur votre dossier. Nous vous invitons à vous rapprocher de nos services pour plus de précisions.",
        "Like this mission": "Aimez cette mission",
        "Type": "Type",
        "All types": "Tous les types",
        "Site": "Site",
        "All sites": "Tous les sites",
        "Customs type": "Type de douane",
        "Dates": "Dates",
        "All customs types": "Tous les types de douane",
        "Are you sure you want to delete this mission ?": "Êtes-vous sûr de vouloir supprimer cette intervention ?",
        "Delete comment": "Laisser un commentaire afin de justifier la suppression de cette intervention",
        "Delete": "Supprimer",
        "Filter": "Filtrer",
        "Export": "Exporter",
        "Events": "Événements",
        "events": {
            "new_message": "Nouveau message dans la conversation",
            "new_document": "Nouveau document",
            "new_message_at": "Nouveau message posté le",
            "new_message_by": "par"
        }
    },
    "en": {
        "My missions": "My missions",
        "My archived missions": "My archived missions",
        "View my archived missions": "View archived missions",
        "View my current missions": "View current missions",
        "No missions": "No missions",
        "Reference": "Reference",
        "Reference ASA": "Reference ASA",
        "Edit reference": "Edit reference",
        "Set your reference": "Set your reference",
        "Set your document name": "Set your document name",
        "Set your registrations": "Set your registrations",
        "Set your notes": "Set your notes",
        "Date": "Date",
        "Status": "Status",
        "report": "report",
        "Price": "Price",
        "Details": "Details",
        "Notes": "Notes",
        "Billing": "Billing",
        "Service": "Service",
        "Quantity": "Quantity",
        "Total": "Total",
        "Empty messages": "Empty messages for the moment",
        "Total services amount :": "Total services amount :",
        "statuses": {
            "current": "current",
            "pending": "pending",
            "achieved": "achieved"
        },
        "Registration trailer": "Trailer registration",
        "Registration towing": "Truck registration",
        "Empty checkpoints": "AEmpty checkpoints",
        "Checkpoints": "Checkpoints",
        "Documents": "Documents",
        "Pictures": "Pictures",
        "Empty documents": "Empty documents",
        "Add a document": "Add a document...",
        "Your truck :": "Your truck :",
        "Started on :": "Started on :",
        "Ended on :": "Ended on :",
        "Duration :": "Duration :",
        "Status of mission": "Status of mission",
        "Messenger": "Conversation",
        "Document name required": "The name of the document is mandatory, it must contain at least 5 characters. Please verify that the document type is not already listed.",
        "Additional costs": "Dear customer, we inform you that additional costs are in progress on your file. We invite you to contact our services for more details.",
        "Like this mission": "Like this mission",
        "Type": "Type",
        "All types": "All types",
        "Site": "Site",
        "All sites": "All sites",
        "Customs type": "Customs type",
        "All customs types": "All customs types",
        "Are you sure you want to delete this mission ?": "Are you sure you want to delete this mission ?",
        "Delete comment": "Leave a comment to justify the deletion of this mission",
        "Delete": "Delete",
        "Filter": "Filter",
        "Export": "Export",
        "Events": "Events",
        "events": {
            "new_message": "New message in conversation",
            "new_document": "New document",
            "new_message_at": "New message posted at",
            "new_message_by": "by"
        }
    }
}
